import {FaTrash} from "react-icons/fa";
import {FaPencil} from "react-icons/fa6";
import {getUrl} from "../../../constants/urls";

export const ACTIONS_LIST = [
  {label: "Edit", icon: FaPencil, perms: ["change_group"]},
  {label: "Delete", icon: FaTrash, perms: ["delete_group"]},
];

export const LIST_HEADERS = ["id", "total_user_count", "name"];

export const groupListURL = getUrl("listGroup");

export const PERMS_FOR_ACTIONS = ["change_group", "delete_group"];
